(function(){
  'use strict';

  angular.module('codecutoff').controller('HomepageController', [
    '$http', 'Collection', 'Product',

    function($http, Collection, Product){
      var vm = this;
      vm.collections = {};
      vm.products = {};
      vm.addCart = addCart;

      getFeaturedCollection();
      getProducts();

      function getFeaturedCollection() {
        Collection.getAll().then(
          function success(response) {
            vm.collections = response;
          }
        );
      }

      function getProducts() {
        Product.getAll().then(
          function success(response) {
            vm.products = response;
          }
        );
      }

      function addCart(product, quantity) {
        var data = {
          quantity: parseInt(quantity),
          id: parseInt(product)
        };

        return $http({
          method: 'POST',
          data: data,
          url: '/cart/add.js'
        }).then(
          function success(response) {
            var cartCount = document.getElementById('cart-count');
            var newCount = parseInt(cartCount.innerHTML) + parseInt(quantity);
            console.log(newCount)
            cartCount.innerHTML = parseInt(newCount);
          }
        );
      }
    }]);
})();
